export const title = 'V-LAB Sigue la formula secreta'
export const description =
  'Ayuda a V-Bot a crear productos Nosotras para que lleguen a más mujeres alrededor del mundo.   V-lab es un juego de memoria en donde debes recrear la fórmula en el orden correcto.'
